import Vue from "vue";
import Vuex from "vuex";
import live from "./modules/live";
import { environment } from "./environment";
import _lodash from "lodash";
import discussionBoardActions from "./discussionBoard/actions";
import newLiveActions from "./newLive/actions";
import newLiveMutations from "./newLive/mutations";
import newLiveStates from "./newLive/state";
var CryptoJS = require("crypto-js");

var promiseRetry = require("promise-retry");
Vue.use(Vuex);

function openTab(url) {
  // Create link in memory
  var a = window.document.createElement("a");
  a.target = "_blank";
  a.href = url;

  // Dispatch fake click
  var e = window.document.createEvent("MouseEvents");
  e.initMouseEvent(
    "click",
    true,
    true,
    window,
    0,
    0,
    0,
    0,
    0,
    false,
    false,
    false,
    false,
    0,
    null
  );
  a.dispatchEvent(e);
}
function openTabV2(url, data) {
  // token=${getters.token}&idexam=${payload.idexam}&idlecture=${payload.idlecture}&idcourse=${payload.idcourse}
  let jsonData = JSON.stringify(data);
  let secret = "kJYSb2aTHqa3JBGV";
  let encrypted = CryptoJS.AES.encrypt(jsonData, secret);
  let ticket = encrypted.toString();
  let ticket_encodeURI = encodeURIComponent(ticket);

  // let decrypted = CryptoJS.AES.decrypt(encrypted.toString(), secret);
  // let object = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  // Create link in memory
  // var a = window.document.createElement("a");
  // a.target = "_blank";
  // a.href = `${url}?ticket=${ticket_encodeURI}`;

  // // Dispatch fake click
  // var e = window.document.createEvent("MouseEvents");
  // e.initMouseEvent(
  //   "click",
  //   true,
  //   true,
  //   window,
  //   0,
  //   0,
  //   0,
  //   0,
  //   0,
  //   false,
  //   false,
  //   false,
  //   false,
  //   0,
  //   null
  // );
  // a.dispatchEvent(e);
  window.open(`${url}?ticket=${ticket_encodeURI}`, "_blank");
}

export default new Vuex.Store({
  modules: {
    live,
  },
  state: {
    ...newLiveStates,
    api: environment.domain,
    serverName: environment.serverName,
    firebaseDomain: environment.firebaseDomain,
    // api: "http://tula-api-sandbox.deknerd.com/api",
    // serverName: "TEST",
    // classroom
    sections: [],
    lowerDiaplay: null,
    upperDisplay: null,
    learningLecture: {},
    dashboardHeaders: [],
    showDashboard: false,
    exam: null,
    images: null,
    dialogExamClass: "",
    dialogImageLectureClass: "",
    fetchHeaders: {},
    courseId: null,
    token: null,
    dialogImageCurrentUrl: null,
    currentImage: "",
    videoCurrentTime: 0,
    ticketId: "",
    statusCode: null,
    courseTitle: "",
    courseImage: "",
    hLiveId: "",
    hCourseId: "",
    lives: [],
    liveUrl: "",
    liveDetail: {},
    availableLiveContect: [],
    limages: [],
    lpdfs: [],
    lurls: [],
    livePdfs: [],
    liveWebsites: [],
    liveImages: [],
    liveQuestion: null,
    liveNotification: null,
    endLiveNotification: null,
    serverDiffTime: 0,
    question: {},
    hisLiveStreamID: "",
    hisOnlineCourseID: "",
    learningOrder: null,
    learningLectureFromService: [],
    updateVideoTime: {},
    updatePostList: {},
    updateDiscusstionPostList: {},
    gotoExamNow: false,
    goToExamPayload: null,
    // examPlayerEndpoint: "http://localhost:8082",
    examPlayerEndpoint: "https://exam-reader.nerdof.com",
    newLive: false,
    pdfDrawing: null,
    loadingPdfDrawing: false,
    savingPdfDrawing: false,
    sendQuizError: null,
    paymentAvailable: false,
    loadSkelton: false
  },
  mutations: {
    setPayment(state, val) {
      state.paymentAvailable = val
    },
    ...newLiveMutations,
    //classroom
    addLectures(state, sections) {
      state.sections = [];
      sections.forEach((section) => {
        state.sections.push({
          lectures: section.lectures,
          priority: section.priority,
          title: section.title,
          id: section._id,
          ...section.teacher,

        });
      });
    },
    initLive(state, ids) {
      state.hCourseId = ids[0];
      state.hLiveId = ids[1];
    },
    setCourseTitle(state, payload) {
      state.courseTitle = payload;
    },
    setCourseImage(state, payload) {
      state.courseImage = payload;
    },
    setHisOnlineCourse(state, payload) {
      state.hisOnlineCourseID = payload;
    },
    setLives(state, lives) {
      state.lives = lives;
    },
    setLiveUrl(state, liveUrl) {
      state.liveUrl = liveUrl;
    },
    setLowerDisplay(state, payload) {
      state.loadSkelton = false
      state.lowerDiaplay = payload;
    },
    setLoadingLowerDisplay(state, payload) {
      state.loadSkelton = payload
    },
    setUpperDisplay(state, payload) {
      state.upperDisplay = payload;
    },
    updateVideoTime(state, data) {
      state.updateVideoTime = data;
    },
    updatePostList(state, data) {
      state.updatePostList = data;
    },
    updateDiscusstionPostList(state, data) {
      state.updateDiscusstionPostList = data;
    },
    updateLearningLecture(state, data) {
      const courseHistory = data.data.result.history;
      const learningLecture = {};
      if (
        courseHistory.learningSection &&
        courseHistory.learningSection.length > 0
      ) {
        courseHistory.learningSection.forEach((eachLearningSection) => {
          eachLearningSection.learningLecture.forEach((eachLearningLecture) => {
            learningLecture[eachLearningLecture.lecture] = eachLearningLecture;
          });
        });
        state.learningLecture = learningLecture;
        state.learningLectureFromService =
          data.data.result.history.learningSection;
        state.learningOrder = state.learningOrder
          ? state.learningOrder
          : data.data.result.learningOrder;
      }
      state.learningLectureFromService =
        data.data.result.history.learningSection;
      state.learningOrder = state.learningOrder
        ? state.learningOrder
        : data.data.result.learningOrder;
    },
    updateLearningLecturePercent(state, { _id, percent }) {
      if (state.learningLecture[_id]) {
        state.learningLecture[_id].percent = percent;
      }
    },
    updateDashboardHeader(state, sections) {
      const dashboardHeaders = {};
      sections.forEach((section) => {
        section.lectures.forEach((lecture) => {
          if (dashboardHeaders[lecture.type]) {
            dashboardHeaders[lecture.type] += 100;
          } else {
            dashboardHeaders[lecture.type] = 100;
          }
        });
      });
      state.dashboardHeaders = dashboardHeaders;
    },
    toggleDashboard(state) {
      state.showDashboard = !state.showDashboard;
    },
    updateExam(state, exam) {
      state.exam = exam;
    },
    updateGoToExamPayload(state, goToExamPayload) {
      state.goToExamPayload = goToExamPayload;
    },
    updateImage(state, images) {
      const imageWithSelectStatus = images.urls.map((url) => {
        return { url };
      });
      imageWithSelectStatus[0].selected = true;
      state.images = imageWithSelectStatus;
    },
    updateImageSelected(state, selectedUrl) {
      (state.images || []).forEach((image) => {
        image.selected = image.url === selectedUrl;
      });
      state.currentImage = selectedUrl;
    },
    setDialogExamClass(state, className) {
      state.dialogExamClass = className;
    },
    setDialogImageLectureClass(state, payload) {
      state.dialogImageLectureClass = payload.className;
      // state.selectImageUrl = payload.url;
    },
    initCourseIdAndToken(state, { courseId, token }) {
      state.courseId = courseId;
      state.token = token;
    },
    setDialogImageCurrentUrl(state, url) {
      state.dialogImageCurrentUrl = url;
    },
    updateVideoCurrentTime(state, timestamp) {
      state.videoCurrentTime = timestamp;
    },
    updateTicketId(state, ticketId) {
      state.ticketId = ticketId;
    },
    updateStatusCode(state, statusCode) {
      state.statusCode = statusCode;
    },
    updateLiveNotification: (state, payload) => {
      state.liveNotification = payload;
    },
    updateEndLiveNotification: (state, payload) => {
      state.endLiveNotification = payload;
    },
    updateLiveQuestion: (state, payload) => {
      state.liveQuestion = payload;
    },
    closeLiveQuestion: (state) => {
      state.sendQuizError += 1;
    },
    setQuestion: (state, payload) => {
      state.question = payload;
    },
    setServerDiffTime(state, serverDiffTime) {
      state.serverDiffTime = serverDiffTime;
    },
    setPdfDrawing(state, pdfDrawing) {
      state.pdfDrawing = pdfDrawing;
    },
    setLoadingPdfDrawing(state, loadingPdfDrawing) {
      state.loadingPdfDrawing = loadingPdfDrawing;
    },
    setSavingPdfDrawing(state, savingPdfDrawing) {
      state.savingPdfDrawing = savingPdfDrawing
    }
  },
  getters: {
    vue(state) {
      return this._vm;
    },
    serverDiffTime: (state) => {
      return state.serverDiffTime;
    },
    loadSkelton: (state) => {
      return state.loadSkelton;
    },
    hisLiveStreamID: (state) => {
      return state.hisLiveStreamID;
    },
    hisOnlineCourseID: (state) => {
      return state.hisOnlineCourseID;
    },
    endLiveNotification: (state) => {
      return state.endLiveNotification;
    },
    liveNotification: (state) => {
      return state.liveNotification;
    },
    liveQuestion: (state) => {
      return state.liveQuestion;
    },
    livePdfs: (state) => {
      return state.livePdfs;
    },
    liveImages: (state) => {
      return state.liveImages;
    },
    liveWebsites: (state) => {
      return state.liveWebsites;
    },
    liveId: (state) => {
      return state.hLiveId;
    },
    locale: () => {
      return localStorage.getItem("locale") || "en";
    },
    courseTitle: (state) => {
      return state.courseTitle;
    },
    courseImage: (state) => {
      return state.courseImage;
    },
    // classroom
    token: (state) => {
      return state.token;
    },
    courseId: (state) => {
      return state.courseId;
    },
    requestHeaders: (state, getters) => {
      return {
        headers: {
          "server-name": state.serverName,
          "x-session-token": getters.token,
        },
      };
    },
    lowerDisplay: (state) => {
      return state.lowerDiaplay;
    },
    upperDisplay: (state) => {
      return state.upperDisplay;
    },
    learningLecture: (state) => {
      return state.learningLecture;
    },
    currentDisplayIds: (state) => {
      const upperDisplay = state.upperDisplay;
      const lowerDiaplay = state.lowerDiaplay;
      const ids = [];
      if (upperDisplay) {
        ids.push(upperDisplay["lecture"]["_id"]);
      }
      if (lowerDiaplay) {
        ids.push(lowerDiaplay["lecture"]["_id"]);
      }
      return ids;
    },
    dashboardHeaders: (state) => {
      return state.dashboardHeaders;
    },
    getShowDashboard: (state) => {
      return state.showDashboard;
    },
    exam: (state) => {
      return state.exam;
    },
    dialogExamClass: (state) => {
      return state.dialogExamClass;
    },
    dialogImageLectureClass: (state) => {
      return state.dialogImageLectureClass;
    },
    images: (state) => {
      return state.images;
    },
    dialogImageCurrentUrl: (state) => {
      return state.dialogImageCurrentUrl;
    },
    videoPermission: (state, getters) => (id, previousId) => {
      if (getters.learningLecture[id]) {
        return true;
      } else if (
        getters.learningLecture[previousId] &&
        !getters.learningLecture[id] &&
        getters.learningLecture[previousId].percent === 100
      ) {
        return true;
      }
      return false;
    },
    examPermission: (getters) => (lectures, examLectureId) => {
      const beforeExamLectures = [];
      for (let i = 0; i < lectures.length; i++) {
        if (lectures[i]._id === examLectureId) {
          break;
        }
        beforeExamLectures.push(lectures[i]);
      }
      const historyCount = beforeExamLectures
        .map((l) => l._id)
        .map((id) => Object.keys(getters.learningLecture).indexOf(id) > -1);
      return !historyCount.some((h) => h === false);
    },
    videoCurrentTime: (state) => {
      return state.videoCurrentTime;
    },
    urlQueryParameter: () => (prefixUrl, options) => {
      let queryParameter = "";
      const parameterNames = Object.keys(options);
      parameterNames.forEach((parameterName, index) => {
        if (parameterName !== "lecture") {
          queryParameter += `${parameterName}=${options[parameterName]}`;
          if (index + 1 < parameterNames.length) {
            queryParameter += "&";
          }
        }
      });
      return `${prefixUrl}?${queryParameter}`;
    },
    ticketId: (state) => {
      return state.ticketId;
    },
    statusCode: (state) => {
      return state.statusCode;
    },
    liveUrl: (state) => {
      return state.liveUrl;
    },
    liveDetail: (state) => {
      return state.liveDetail;
    },
    serverDiffTime: (state) => {
      return state.serverDiffTime;
    },
    question: (state) => {
      return state.question;
    },
    dialogCountdownTime: (getters) => (target) => {
      const timeRequest = target.timeRequest;
      const delay = target.delay;
      const targetTime = timeRequest + delay;
      const currentTime = new Date().getTime();
      let timeLeft = targetTime - currentTime;
      timeLeft += getters.serverDiffTime;
      return timeLeft;
    },
    learningOrder: (state) => {
      return state.learningOrder;
    },
    learningLectureFromService: (state) => {
      return state.learningLectureFromService;
    },
    updateVideoTime: (state) => {
      return state.updateVideoTime;
    },
    updatePostList: (state) => {
      return state.updatePostList;
    },
    updateDiscusstionPostList: (state) => {
      return state.updateDiscusstionPostList;
    },
    getGoToExamPayload: (state) => {
      return state.goToExamPayload;
    },
    getPdfDrawing: (state) => {
      return state.pdfDrawing;
    },
    getLoadingPdfDrawing: (state) => {
      return state.loadingPdfDrawing;
    },
    getSavingPdfDrawing: (state) => {
      return savingPdfDrawing;
    }
  },
  actions: {
    ...newLiveActions,
    fetchDrawing({ commit, getters, state }, payload) {
      commit("setLoadingPdfDrawing", true);
      const url = getters.urlQueryParameter(`${environment.firebaseDomain}/drawing-getAll`,
        payload
      );
      Vue.axios.get(url, getters.requestHeaders).then((res) => {
        var temp = {};

        if (res.data.result != null) {
          temp = { fileID: res.data.result.fileID, userID: res.data.result.userID, lastEdited: res.data.result.lastEdited, pages: [] };
        } else {
          temp = { fileID: payload.fileID, userID: payload.userID, lastEdited: 1, pages: [] };
        }

        if (res.data.result != null) {
          for (var i = 0; i < res.data.result.pages.length; i++) {
            temp.pages[res.data.result.pages[i].pageNo] = { layers: res.data.result.pages[i].layers };
          }
        }
        commit("setPdfDrawing", temp);
        commit("setLoadingPdfDrawing", false);
      });
    },
    sendDrawing({ commit, state, getters }) {
      commit("setSavingPdfDrawing", true);
      console.log(state.pdfDrawing);
      const removePayload = {
        fileID: state.pdfDrawing.fileID,
        userID: state.pdfDrawing.userID
      };

      var createPayload = {
        fileID: state.pdfDrawing.fileID,
        userID: state.pdfDrawing.userID,
        lastEdited: state.pdfDrawing.lastEdited,
        pages: []
      };

      for (const [key, value] of Object.entries(state.pdfDrawing.pages)) {
        createPayload.pages.push({ pageNo: key, layers: value.layers });
      }

      const removeUrl = `${environment.firebaseDomain}/drawing-removeAllByUser`;
      Vue.axios.put(removeUrl, removePayload, getters.requestHeaders).then((res) => {
        const createUrl = `${environment.firebaseDomain}/drawing-create`;
        Vue.axios.post(createUrl, createPayload, getters.requestHeaders).then((res) => {
          commit("setSavingPdfDrawing", false);
        });
      });
    },
    fetchSections({ commit, getters, state }, courseId) {
      return Vue.axios
        .get(
          `${state.api}/course/section/detail?idcourse=${courseId}`,
          getters.requestHeaders
        )
        .then((data) => {
          commit("addLectures", data.data.result.detail);
          commit("updateLearningLecture", data);
          commit("updateDashboardHeader", data.data.result.detail);
          commit("setCourseTitle", data.data.result.title);
          commit("setCourseImage", data.data.result.image);
          commit("setHisOnlineCourse", data.data.result.hisOnlineCourseID);
          // if (data.data.result.Live_LivestreamsV2) {
          state.newLive = true;
          data.data.result.Live_LivestreamsV2.forEach(l => {
            l.newLive = true;
          });
          commit("setLives", data.data.result.Live_LivestreamsV2);
          // }
          // else if (data.data.result.livestreams && data.data.result.livestreams.length > 0) {
          //   state.newLive = false;
          //   commit("setLives", data.data.result.livestreams);
          // }
        });
    },
    changeDisplay({ dispatch, commit }, payload) {
      if (payload.lecture.type === "PDF") {
        commit("setLoadingLowerDisplay", true);
        dispatch("fetchPdf", {
          ...payload,
          idpdf: payload.lecture.pdf[0]._id,
          isDownload: payload.lecture.isDownload,
        });
      } else if (payload.lecture.type === "IMG") {
        commit("setLoadingLowerDisplay", true);
        dispatch("fetchImage", payload);
      } else if (payload.lecture.type === "BOOK") {
        commit("setLoadingLowerDisplay", true);
        dispatch("fetchBook", {
          ...payload,
          idbook: payload.lecture.books[0]._id,
          isDownload: payload.lecture.isDownload,
        });
      } else if (payload.lecture.type === "VDO") {
        dispatch("fetchVideo", {
          ...payload,
          idvideo: payload.lecture.video[0]._id,
        });
      } else if (payload.lecture.type === "URL") {
        commit("setLoadingLowerDisplay", true);
        dispatch("fetchUrl", payload);
      } else if (payload.lecture.type === "BLOG") {
        commit("setLoadingLowerDisplay", true);
        dispatch("fetchBlog", {
          ...payload,
          idblog: payload.lecture.blogs[0]._id,
        });
      } else if (payload.lecture.type === "EXAM") {
        commit("setLoadingLowerDisplay", true);
        dispatch("fetchExam", {
          ...payload,
          idexam: payload.lecture.exams[0]._id,
        });
      } else if (payload.lecture.type === "FILE") {
        dispatch("fetchFile", {
          ...payload,
          idfile: payload.lecture.file[0]._id,
        });
      } else if (payload.lecture.type === "YOUTUBE") {
        dispatch("fetchYoutube", {
          ...payload,
          idyoutube: payload.lecture.youtube[0]._id,
        });
      }
    },
    fetchPdf({ commit, getters, state }, payload) {
      const url = getters.urlQueryParameter(
        `${state.api}/uploadfile/getfile/pdf`,
        payload
      );
      Vue.axios.get(url, getters.requestHeaders).then((res) => {
        commit("setLowerDisplay", {
          lecture: payload.lecture,
          fetchData: _lodash.assign({ ...res.data.result, idpdf: payload.idpdf }, {
            isDownload: payload.isDownload,
          }),
        });
        commit("updateLearningLecture", res);
      });
    },
    fetchBook({ commit, getters, state }, payload) {
      const url = getters.urlQueryParameter(
        `${state.api}/book/detail`,
        payload
      );
      Vue.axios.get(url, getters.requestHeaders).then((res) => {
        commit("setLowerDisplay", {
          lecture: payload.lecture,
          fetchData: _lodash.assign(res.data.result, {
            isDownload: payload.isDownload,
          }),
        });
        commit("updateLearningLecture", res);
      });
    },
    fetchImage({ commit, getters, state }, payload) {
      const url = getters.urlQueryParameter(
        `${state.api}/uploadfile/getfile/image`,
        payload
      );
      Vue.axios.get(url, getters.requestHeaders).then((res) => {
        commit("setLowerDisplay", {
          lecture: payload.lecture,
          fetchData: res.data.result,
        });
        commit("updateImage", res.data.result);
        commit("updateLearningLecture", res);
      });
    },
    forceFetchImage({ commit }) {
      const lecture = JSON.parse(
        '{"image":[{"active":true,"_id":"5ea66b55703dc757e34a4431","size":4903,"type":"image/png","title":"4945bf8d-f841-43c2-8b04-f5ede5abd27a.png","created_at":1587964757239},{"active":true,"_id":"5ea66b55703dc757e34a4432","size":2311,"type":"image/png","title":"10531e23-b171-4640-a245-a6bc1dcdffaa.png","created_at":1587964757244},{"active":true,"_id":"5ea66b55703dc757e34a4433","size":4259,"type":"image/png","title":"eb07ded3-baa9-4812-b517-794555bc30e5.png","created_at":1587964757255},{"active":true,"_id":"5ea66b55703dc757e34a4434","size":191286,"type":"image/png","title":"b5781a44-ddde-4913-9d71-a8c21aca0025.png","created_at":1587964757456},{"active":true,"_id":"5ea66b55703dc757e34a4435","size":338373,"type":"image/png","title":"1aeebc50-2f73-4c46-8c15-4d8598137329.png","created_at":1587964757516}],"pdf":[],"video":[],"youtube":[],"file":[],"exams":[],"books":[],"blogs":[],"priority":4,"_id":"5ea66b65703dc757e34a4436","title":"Basic mathematical formulas","type":"IMG"}'
      );
      const fetchData = JSON.parse(
        '{"urls":["https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/private/image/course/4945bf8d-f841-43c2-8b04-f5ede5abd27a.png?AWSAccessKeyId=AKIA4FOOGXQPZUV4NTFM&Expires=1591771396&Signature=p9CjUMpJtqE56fbl6TH%2FBhzjAEM%3D","https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/private/image/course/10531e23-b171-4640-a245-a6bc1dcdffaa.png?AWSAccessKeyId=AKIA4FOOGXQPZUV4NTFM&Expires=1591771396&Signature=whUfdocicO3M%2BKK%2BrRFxQGY4KRY%3D","https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/private/image/course/eb07ded3-baa9-4812-b517-794555bc30e5.png?AWSAccessKeyId=AKIA4FOOGXQPZUV4NTFM&Expires=1591771396&Signature=hmopVg6h3xnehSj9nGRB6phSs9I%3D","https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/private/image/course/b5781a44-ddde-4913-9d71-a8c21aca0025.png?AWSAccessKeyId=AKIA4FOOGXQPZUV4NTFM&Expires=1591771396&Signature=894blselfVnt%2BS36QFCCeJmQtHw%3D","https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/private/image/course/1aeebc50-2f73-4c46-8c15-4d8598137329.png?AWSAccessKeyId=AKIA4FOOGXQPZUV4NTFM&Expires=1591771396&Signature=tV93wJu%2FAMHtHEHykRDbEhJUG2A%3D"],"history":{"acceptMylib":true,"isMylib":true,"percent":30,"active":true,"companies":["5ea54139b92b35fbf76933af"],"_id":"5eb0e7838a85223ed6bac056","course":"5ea54d75703dc757e34a4207","learningSection":[{"percent":90,"learningLecture":[{"type":"BOOK","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ebf8f73a5ffdf02a951f1ea","lecture":"5ebe61fea5ffdf02a951f044","exams":null},{"type":"VDO","percent":100,"videoCurrentTime":22196,"videoMaxTime":386046,"videoTime":385000,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ebfa7f1a5ffdf02a951f1f3","lecture":"5ea54dba703dc757e34a422c","video":"5ea54db3ab7d753b8dccee0e","exams":null},{"type":"BLOG","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ebfa7f4a5ffdf02a951f1fa","lecture":"5ea66c04703dc757e34a4449"},{"type":"URL","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ec15d6ea5ffdf02a95202dc","lecture":"5ea66bb5703dc757e34a4440"},{"type":"IMG","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ec15d74a5ffdf02a95202e4","lecture":"5ea66b65703dc757e34a4436"},{"type":"EXAM","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":3,"sumScore":7,"avgScore":87.5,"_id":"5ec3e8bd49bb940697232e14","lecture":"5ea691d0703dc757e34a464d","video":null,"exams":"5ea691d0703dc757e34a4647"},{"type":"PDF","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ec3e8cb49bb940697232e20","lecture":"5ea66b95703dc757e34a443b"},{"type":"PDF","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ecb6329467efe0918187eb3","lecture":"5ebe671fa5ffdf02a951f062"},{"type":"EXAM","percent":0,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ecb633f467efe0918187ece","lecture":"5ebd1817e2612059ead86204","video":null,"exams":"5ebd1817e2612059ead86202"},{"type":"YOUTUBE","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5eccb73bdd95101ed9f36cb6","lecture":"5eccb733dd95101ed9f36caa"}],"_id":"5ebf8f73a5ffdf02a951f1e8","section":"5ea54d8f703dc757e34a4215"}],"student":"5ea544c4e24227fd209e0e03","room":"5ea54f89703dc757e34a43a0","created_at":1588651907977,"__v":0,"examsList":[{"avgScore":39.29,"_id":"5ee07126efa62f60ae598620","exams":"5ea691d0703dc757e34a4647"},{"avgScore":0,"_id":"5ee07126efa62f60ae598621","exams":"5ebd1817e2612059ead86202"}],"videosList":[{"percent":100,"_id":"5ee07126efa62f60ae598622","videos":"5ea54db3ab7d753b8dccee0e"}],"learningLivestream":[]}}'
      );
      commit("setLowerDisplay", { lecture, fetchData });
    },
    forceFetchPdf({ commit, getters }, payload) {
      const lecture = JSON.parse(
        '{"image":[],"pdf":[{"active":true,"_id":"5ea66b89703dc757e34a443a","size":759201,"type":"application/pdf","title":"a31676d1-3fa4-4646-996e-e6f882a12264.pdf","created_at":1587964809881}],"video":[],"youtube":[],"file":[],"exams":[],"books":[],"blogs":[],"priority":5,"_id":"5ea66b95703dc757e34a443b","title":"Learning Documents","type":"PDF"}'
      );
      const fetchData = JSON.parse(
        '{"url":"https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/private/pdf/course/a31676d1-3fa4-4646-996e-e6f882a12264.pdf?AWSAccessKeyId=AKIA4FOOGXQPZUV4NTFM&Expires=1591771604&Signature=8nFaF5gHZzQqUZN4hzFtIlxKP7o%3D","history":{"acceptMylib":true,"isMylib":true,"percent":30,"active":true,"companies":["5ea54139b92b35fbf76933af"],"_id":"5eb0e7838a85223ed6bac056","course":"5ea54d75703dc757e34a4207","learningSection":[{"percent":90,"learningLecture":[{"type":"BOOK","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ebf8f73a5ffdf02a951f1ea","lecture":"5ebe61fea5ffdf02a951f044","exams":null},{"type":"VDO","percent":100,"videoCurrentTime":22196,"videoMaxTime":386046,"videoTime":385000,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ebfa7f1a5ffdf02a951f1f3","lecture":"5ea54dba703dc757e34a422c","video":"5ea54db3ab7d753b8dccee0e","exams":null},{"type":"BLOG","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ebfa7f4a5ffdf02a951f1fa","lecture":"5ea66c04703dc757e34a4449"},{"type":"URL","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ec15d6ea5ffdf02a95202dc","lecture":"5ea66bb5703dc757e34a4440"},{"type":"IMG","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ec15d74a5ffdf02a95202e4","lecture":"5ea66b65703dc757e34a4436"},{"type":"EXAM","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":3,"sumScore":7,"avgScore":87.5,"_id":"5ec3e8bd49bb940697232e14","lecture":"5ea691d0703dc757e34a464d","video":null,"exams":"5ea691d0703dc757e34a4647"},{"type":"PDF","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ec3e8cb49bb940697232e20","lecture":"5ea66b95703dc757e34a443b"},{"type":"PDF","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ecb6329467efe0918187eb3","lecture":"5ebe671fa5ffdf02a951f062"},{"type":"EXAM","percent":0,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ecb633f467efe0918187ece","lecture":"5ebd1817e2612059ead86204","video":null,"exams":"5ebd1817e2612059ead86202"},{"type":"YOUTUBE","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5eccb73bdd95101ed9f36cb6","lecture":"5eccb733dd95101ed9f36caa"}],"_id":"5ebf8f73a5ffdf02a951f1e8","section":"5ea54d8f703dc757e34a4215"}],"student":"5ea544c4e24227fd209e0e03","room":"5ea54f89703dc757e34a43a0","created_at":1588651907977,"__v":0,"examsList":[{"avgScore":39.29,"_id":"5ee07126efa62f60ae598620","exams":"5ea691d0703dc757e34a4647"},{"avgScore":0,"_id":"5ee07126efa62f60ae598621","exams":"5ebd1817e2612059ead86202"}],"videosList":[{"percent":100,"_id":"5ee07126efa62f60ae598622","videos":"5ea54db3ab7d753b8dccee0e"}],"learningLivestream":[]}}'
      );
      commit("setLowerDisplay", { lecture, fetchData });
    },
    fetchVideo({ commit, getters, dispatch, state }, payload) {
      const url = getters.urlQueryParameter(
        `${state.api}/uploadfile/getfile/video`,
        payload
      );
      Vue.axios.get(url, getters.requestHeaders).then((res) => {
        dispatch("changeVideo");

        commit("setUpperDisplay", {
          lecture: payload.lecture,
          fetchData: res.data.result,
        });
        commit("updateLearningLecture", res);
      });
    },
    forceFetchVideo({ commit, getters, dispatch }, payload) {
      const result = JSON.parse(
        '{"key":"6GLXYWjqhP3q0Ag4FD5G318Z6YX5X23Fh2VFWA5EWmJ","cycle_log":5,"url":"https://deknerdteam-yqavnd.cdn.byteark.com/video-objects/RxFnTcxmxi8j/playlist.m3u8?x_ark_access_id=aJnMS6B3c9K4BUS0KiKz&x_ark_auth_type=ark-v2&x_ark_expires=1591767934.025&x_ark_signature=Nc5sX_ECrGBJCVGMf3a36g","isCheckComplete":true,"isUploadComplete":true,"updateAgain":false,"videoCurrentTime":22196,"videoMaxTime":386046,"videoTime":385000,"history":{"acceptMylib":true,"isMylib":true,"percent":30,"active":true,"companies":["5ea54139b92b35fbf76933af"],"_id":"5eb0e7838a85223ed6bac056","course":"5ea54d75703dc757e34a4207","learningSection":[{"percent":90,"learningLecture":[{"type":"BOOK","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ebf8f73a5ffdf02a951f1ea","lecture":"5ebe61fea5ffdf02a951f044","exams":null},{"type":"VDO","percent":100,"videoCurrentTime":22196,"videoMaxTime":386046,"videoTime":385000,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ebfa7f1a5ffdf02a951f1f3","lecture":"5ea54dba703dc757e34a422c","video":"5ea54db3ab7d753b8dccee0e","exams":null},{"type":"BLOG","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ebfa7f4a5ffdf02a951f1fa","lecture":"5ea66c04703dc757e34a4449"},{"type":"URL","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ec15d6ea5ffdf02a95202dc","lecture":"5ea66bb5703dc757e34a4440"},{"type":"IMG","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ec15d74a5ffdf02a95202e4","lecture":"5ea66b65703dc757e34a4436"},{"type":"EXAM","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":3,"sumScore":7,"avgScore":87.5,"_id":"5ec3e8bd49bb940697232e14","lecture":"5ea691d0703dc757e34a464d","video":null,"exams":"5ea691d0703dc757e34a4647"},{"type":"PDF","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ec3e8cb49bb940697232e20","lecture":"5ea66b95703dc757e34a443b"},{"type":"PDF","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ecb6329467efe0918187eb3","lecture":"5ebe671fa5ffdf02a951f062"},{"type":"EXAM","percent":0,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5ecb633f467efe0918187ece","lecture":"5ebd1817e2612059ead86204","video":null,"exams":"5ebd1817e2612059ead86202"},{"type":"YOUTUBE","percent":100,"videoCurrentTime":0,"videoMaxTime":0,"videoTime":0,"examTerm":0,"sumScore":0,"avgScore":0,"_id":"5eccb73bdd95101ed9f36cb6","lecture":"5eccb733dd95101ed9f36caa"}],"_id":"5ebf8f73a5ffdf02a951f1e8","section":"5ea54d8f703dc757e34a4215"}],"student":"5ea544c4e24227fd209e0e03","room":"5ea54f89703dc757e34a43a0","created_at":1588651907977,"__v":0,"examsList":[{"avgScore":39.29,"_id":"5ee07126efa62f60ae598620","exams":"5ea691d0703dc757e34a4647"},{"avgScore":0,"_id":"5ee07126efa62f60ae598621","exams":"5ebd1817e2612059ead86202"}],"videosList":[{"percent":100,"_id":"5ee07126efa62f60ae598622","videos":"5ea54db3ab7d753b8dccee0e"}],"learningLivestream":[]}}'
      );
      commit("setLiveUrl", result.url);
    },
    fetchUrl({ commit, getters, state }, payload) {
      const url = getters.urlQueryParameter(
        `${state.api}/uploadfile/getfile/url`,
        payload
      );
      Vue.axios.get(url, getters.requestHeaders).then((res) => {
        window.open(res.data.result.urls[0], "_blank");
        commit("updateLearningLecture", res);
      });
    },
    fetchBlog({ commit, getters, state }, payload) {
      const url = getters.urlQueryParameter(
        `${state.api}/uploadfile/getfile/blog`,
        payload
      );
      Vue.axios.get(url, getters.requestHeaders).then((res) => {
        commit("setLowerDisplay", {
          lecture: payload.lecture,
          fetchData: res.data.result,
        });
        commit("updateLearningLecture", res);
      });
    },
    fetchExam({ commit, getters, state }, payload) {
      const url = getters.urlQueryParameter(
        `${state.api}/exam/detail`,
        payload
      );
      Vue.axios.get(url, getters.requestHeaders).then((res) => {
        commit("updateExam", res.data.result);
        commit("setDialogExamClass", "open");
        commit("updateLearningLecture", res);
        commit("updateStatusCode", res.data.result.status);
        commit("setLowerDisplay", {
          lecture: payload.lecture,
          fetchData: _lodash.assign({ ...res.data.result, idexam: payload.idexam }, {
            isDownload: payload.isDownload,
          }),
        });
      });
      commit("updateGoToExamPayload", payload);
    },
    fetchFile({ commit, getters, state }, payload) {
      const url = getters.urlQueryParameter(
        `${state.api}/uploadfile/getfile/file`,
        payload
      );
      Vue.axios.get(url, getters.requestHeaders).then((res) => {
        window.open(res.data.result.url, "_blank");
        commit("updateLearningLecture", res);
      });
    },
    fetchYoutube({ commit, getters, dispatch, state }, payload) {
      const url = getters.urlQueryParameter(
        `${state.api}/uploadfile/getfile/youtube`,
        payload
      );
      Vue.axios.get(url, getters.requestHeaders).then((res) => {
        // window.open('https://www.youtube.com/watch?v='+ res.data.result.idyoutube, "_blank");
        // commit('updateLearningLecture', res);
        dispatch("changeVideo");
        commit("setUpperDisplay", {
          lecture: payload.lecture,
          fetchData: {
            ...res.data.result,
            url: "https://www.youtube.com/embed/" + res.data.result.idyoutube,
          },
        });
        commit("updateLearningLecture", res);
      });
    },
    closeExam({ getters, state }, ticketId) {
      const url = `${state.api}/exam/detail/finish`;
      Vue.axios
        .post(
          url,
          {
            ticket: ticketId,
          },
          getters.requestHeaders
        )
        .then(() => { });
    },
    fetchTicket({ commit, getters, state, dispatch }, { payload, ticket }) {
      // const url = getters.urlQueryParameter(`${environment.firebaseDomain}/startState`, payload);
      // const url = getters.urlQueryParameter(`${state.api}/exam/detail/startstate`, payload);

      // let ticketId;
      // if (ticket.length > 0 && ticket[ticket.length - 1].summaryAns == false) {
      //   if (
      //     ticket[ticket.length - 1].endtime === 0 ||
      //     ticket[ticket.length - 1].endtime > new Date().getTime()
      //   ) {
      //     commit('updateTicketId', ticket[ticket.length - 1]._id);
      //     commit('updateStatusCode', '');
      //     ticketId = ticket[ticket.length - 1]._id;
      //     if (state.gotoExamNow) {
      //       if (ticketId) {
      //         openTab(`${environment.examReaderDomain}/${ticketId}?token=${getters.token}`);
      //       }
      //     }
      //   } else {
      //     dispatch('closeExam', ticket[ticket.length - 1]._id);
      //     Vue.axios
      //       .get(url, getters.requestHeaders)
      //       .then((res) => {
      //         commit('updateTicketId', res.data.result.ticket);
      //         ticketId = res.data.result.ticket;
      //         commit('updateStatusCode', '');
      //         if (state.gotoExamNow) {
      //           if (ticketId) {
      //             openTab(
      //               `${state.examPlayerEndpoint}/#/exam/${ticketId}?token=${getters.token}`,
      //             );
      //           }
      //         }
      //       })
      //       .catch((err) => {
      //         commit('updateStatusCode', err.response.data.statusCode);
      //       });
      //   }
      // } else {
      //   Vue.axios
      //     .get(url, getters.requestHeaders)
      //     .then((res) => {
      //       commit('updateTicketId', res.data.result.ticket);
      //       ticketId = res.data.result.ticket;
      //       commit('updateStatusCode', '');
      //       if (state.gotoExamNow) {
      //         if (ticketId) {
      //           openTab(`${environment.examReaderDomain}/${ticketId}?token=${getters.token}`);
      //         }
      //       }
      //     }).
      //     catch(err => {
      //       commit('updateStatusCode', err.response.data.statusCode)
      //     });
      // }
      // openTab(`${environment.examReaderHomeDomain}?token=${getters.token}&idexam=${payload.idexam}&idlecture=${payload.idlecture}&idcourse=${payload.idcourse}`)
      let data = {
        numStamp: `${Vue.prototype.$userInfo._id}${Date.now()}`,
        token: getters.token,
        idexam: payload.idexam,
        idlecture: payload.idlecture,
        idcourse: payload.idcourse,
      };
      let url = environment.examReaderHomeDomain;
      openTabV2(url, data);
    },
    fetchLImage({ commit, getters, state }, { payload, title }) {
      state.liveImages = [];
      let url = getters.urlQueryParameter(
        `${state.api}/livestream/live/getfile/image`,
        payload
      );
      let mapFunction = (res) => {
        state.liveImages.push({
          title,
          url: res.data.result.url,
        });
        // commit('updateTicketId', res.data.result.ticket);
      }
      if (state.newLive) {
        url = `${state.api}/livestreamv2/${payload.idlivestream}/media/image`;
        mapFunction = (res) => {
          const data = res.data;
          if (data && data.length > 0) {
            data.forEach((d) => {
              if (d.active && d.image) {
                state.liveImages.push({
                  title: d.title,
                  url: d.image,
                });
              }
            });
          }
          // commit('updateTicketId', res.data.result.ticket);
        }
      }
      // Vue.axios.get(url, getters.requestHeaders).then(res => {
      //   state.liveImages.push({
      //     title,
      //     url: res.data.result.url
      //   });
      //   // commit('updateTicketId', res.data.result.ticket);
      // });

      // promiseRetry(function(retry, number) {

      //   return 
      Vue.axios
        .get(url, getters.requestHeaders)
        .then(mapFunction)
      // .catch(retry);
      // }).then(
      //   function() {
      //     // ..
      //   },
      //   function() {
      //     // ..
      //   },
      // );
    },
    fetchLPdf({ commit, getters, state }, { payload, title }) {
      if (state.newLive) {
        state.livePdfs = [];
        const v2Url = `${state.api}/livestreamv2/${payload.idlivestream}/media/pdf/`;
        Vue.axios.get(v2Url, getters.requestHeaders).then((res) => {
          const data = res.data
          data.forEach(r => {
            state.livePdfs.push({
              title: r.title,
              url: r.url,
            });
          })
          // commit('updateTicketId', res.data.result.ticket);
        });
      } else {
        state.livePdfs = [];
        const url = getters.urlQueryParameter(
          `${state.api}/livestream/live/getfile/pdf`,
          payload
        );
        Vue.axios.get(url, getters.requestHeaders).then((res) => {
          state.livePdfs.push({
            title,
            url: res.data.result.url,
          });
          // commit('updateTicketId', res.data.result.ticket);
        });
      }
    },
    fetchLUrl({ commit, getters, state }, { payload, title }) {
      state.liveWebsites = [];
      let url = getters.urlQueryParameter(
        `${state.api}/livestream/live/getfile/url`,
        payload
      );
      let mapFunction = (res) => {
        state.liveWebsites.push({
          title,
          url: res.data.result.url,
        });
      };
      if (state.newLive) {
        url = `${state.api}/livestreamv2/${payload.idlivestream}/media/url`;
        mapFunction = (res) => {
          const data = res.data;
          if (data && data.length > 0) {
            data.forEach((d) => {
              if (d.active && d.url) {
                state.liveWebsites.push({
                  title: d.title,
                  url: d.url,
                });
              }
            });
          }
          // commit('updateTicketId', res.data.result.ticket);
        }
      }
      Vue.axios.get(url, getters.requestHeaders).then(mapFunction);
    },
    fetchLive({ commit, getters, state, dispatch }, { newLive }) {
      state.newLive = newLive;
      let url = getters.urlQueryParameter(`${state.api}/livestream/live`, {
        idcourse: state.hCourseId,
        idlivestream: state.hLiveId,
      });

      if (state.newLive) {
        url = `${state.api}/livestreamv2/${state.hLiveId}`;
      }

      Vue.axios.get(url, getters.requestHeaders).then((res) => {
        let data = res.data.result;
        if (state.newLive) {
          data = res.data;
        }
        if (state.newLive) {

          if (data.streamDetail && data.streamDetail.onDemand) {
            commit("setLiveUrl", [{ file: data.streamDetail.onDemand }]);
          } else {
            commit("setLiveUrl", [{ file: `${data.streamDetail.watchURL}?token=xyz` }]);
          }
        } else {
          commit("setLiveUrl", [{ file: data.watchURL }]);
        }
        state.liveDetail = data;
        state.hisLiveStreamID = data.idHisLivestream;
        const keys = [
          {
            key: "images",
            dispatch: "fetchLImage",
            parameter: "idimage",
            fetchId: "image",
          },
          {
            key: "pdfs",
            dispatch: "fetchLPdf",
            parameter: "idpdf",
            fetchId: "pdf",
          },
          {
            key: "urls",
            dispatch: "fetchLUrl",
            parameter: "idurl",
            fetchId: "_id",
          },
        ];
        const available = [];
        keys.forEach((key) => {
          const payload = {
            idcourse: state.hCourseId,
            idlivestream: state.hLiveId,
          };
          if (state.newLive) {
            dispatch(key.dispatch, {
              payload,
            });
            available.push(key);
          } else {
            if (data[key.key]) {
              if (Array.isArray(data[key.key])) {
                data[key.key].forEach((arr) => {
                  payload[key.parameter] = arr[key.fetchId];
                  dispatch(key.dispatch, { payload, title: arr.title });
                });
              } else {
                payload[key.parameter] = data[key.key][key.fetchId];
                dispatch(key.dispatch, {
                  payload,
                  title: data[key.key].title,
                });
                available.push(key);
              }
            }
          }
        });
        state.availableLiveContect = available;
      });
    },
    goToExamWeb({ state, dispatch, getters }) {
      state.gotoExamNow = true;
      if (getters.exam.status === "ACTIVE") {
        dispatch("fetchExam", getters.getGoToExamPayload).then(() => {
          dispatch("fetchTicket", {
            payload: {
              idcourse: getters.getGoToExamPayload.idcourse,
              idlecture: getters.getGoToExamPayload.idlecture,
              idexam: getters.getGoToExamPayload.idexam,
            },
            ticket: getters.exam.myTicket,
          });
        });
      }
    },
    changeVideo({ dispatch, getters }) {
      if (getters.videoCurrentTime > 0) {
        const payload = {
          key: getters.upperDisplay.fetchData.key,
          currenttime: getters.videoCurrentTime,
          _id: getters.upperDisplay.lecture._id,
        };
        if (getters.upperDisplay.fetchData.key) {
          dispatch("closeVideo", payload);
        }
      }
    },
    closeVideo({ getters, state }, payload) {
      const url = `${state.api}/history/manage/closevideo`;
      Vue.axios
        .post(
          url,
          {
            key: payload.key,
            currenttime: payload.currenttime,
          },
          getters.requestHeaders
        )
        .then((res) => {
          // commit('updateLearningLecturePercent', { _id: payload._id, percent: 100 });
        });
    },
    toggleDashboard({ commit }) {
      commit("toggleDashboard");
    },
    fetchServerTime({ commit, getters, state }, payload) {
      Vue.axios
        .get(`${state.api}/timeserver`, getters.requestHeaders)
        .then((res) => {
          const serverTimestamp = res.data.result;
          const deviceTimestamp = new Date().getTime();
          const diff = deviceTimestamp - serverTimestamp;
          commit("setServerDiffTime", diff);
        });
    },
    fetchQuestion({ commit, state, getters }, payload) {
      // const url = getters.urlQueryParameter(`${state.api}/livestream/live/quiz?idlivestream=${payload.idlivestream}&idquiz=${payload.idquiz}`, getters.requestHeaders);
      // Vue.axios.get(`${state.api}/livestream/live/quiz?idlivestream=${state.hLiveId}&idquiz=${payload.idquiz}`, getters.requestHeaders).then(res => {
      //   commit('setQuestion', res.data.result);
      // });

      // promiseRetry(function(retry, number) {

      //   return 
      if (state.newLive) {
        Vue.axios
          .get(
            `${state.api}/livestreamv2/${state.hLiveId}/quiz/${payload.idquiz}`,
            getters.requestHeaders
          )
          .then((res) => {
            commit("setQuestion", res.data);
          })
      } else {
        Vue.axios
          .get(
            `${state.api}/livestream/live/quiz?idlivestream=${state.hLiveId}&idquiz=${payload.idquiz}`,
            getters.requestHeaders
          )
          .then((res) => {
            commit("setQuestion", res.data.result);
          })
      }
      // .catch(retry);
      // }).then(
      //   function() {
      //     // ..
      //   },
      //   function() {
      //     // ..
      //   },
      // );
    },
    sendNameCheck({ commit, state, getters }) {
      const liveNotification = getters.liveNotification;
      const payload = {
        idcourse: state.hCourseId,
        idlivestream: state.hLiveId,
        timeRequest: new Date().getTime(),
        term: liveNotification.term,
        messageKey: liveNotification.messageKey
      };
      if (state.newLive) {
        const url = `${state.api}/livestreamv2/${payload.idlivestream}/checkin/me`;
        Vue.axios.post(url, payload, getters.requestHeaders).then((res) => {
          commit("updateLiveNotification", null);
        });
      } else {
        const url = `${state.api}/livestream/live/log/student`;
        Vue.axios.put(url, payload, getters.requestHeaders).then((res) => {
          commit("updateLiveNotification", null);
        });
      }
    },
    sendAnswer({ commit, state, getters }, payload) {
      if (state.newLive) {
        const url = `${state.api}/livestreamv2/${state.hLiveId}/quiz/${payload.idquiz}/state`;
        Vue.axios
          .post(
            url,
            {
              idlivestream: state.hLiveId,
              idquiz: payload.idquiz,
              answers: payload.answer != null ? [payload.answer] : [],
              event: payload.event, // answer, ignore, cancel
              messageKey: payload.messageKey
            },
            getters.requestHeaders
          )
          .then((res) => {
            commit("updateLiveQuestion", null);
          })
          .catch((error) => {
            commit("closeLiveQuestion", null);


          });
      } else {
        const url = `${state.api}/livestream/live/answerquiz`;
        Vue.axios
          .post(
            url,
            {
              idlivestream: state.hLiveId,
              idquiz: payload.idquiz,
              idanswer: payload.answer != null ? [payload.answer] : [],
              event: payload.event, // answer, ignore, cancel
              messageKey: payload.messageKey
            },
            getters.requestHeaders
          )
          .then((res) => {
            commit("updateLiveQuestion", null);
          })
          .catch((error) => {
            commit("closeLiveQuestion", null);


          });
      }
    },
  },
  // actions
});
